var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7483_15914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.222168,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7483_15914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4895 9.50065L9.72282 14.2673C9.58949 14.4007 9.43949 14.5007 9.27282 14.5673C9.10615 14.634 8.93949 14.6673 8.77282 14.6673C8.60615 14.6673 8.43949 14.634 8.27282 14.5673C8.10615 14.5007 7.95615 14.4007 7.82282 14.2673L4.88115 11.3257L1.93949 8.38398C1.81726 8.26176 1.72282 8.1201 1.65615 7.95898C1.58949 7.79787 1.55615 7.62843 1.55615 7.45065V2.66732C1.55615 2.30065 1.68671 1.98676 1.94782 1.72565C2.20893 1.46454 2.52282 1.33398 2.88949 1.33398H7.67282C7.8506 1.33398 8.02282 1.3701 8.18949 1.44232C8.35615 1.51454 8.5006 1.61176 8.62282 1.73398L14.4895 7.61732C14.6228 7.75065 14.72 7.90065 14.7812 8.06732C14.8423 8.23398 14.8728 8.40065 14.8728 8.56732C14.8728 8.73399 14.8423 8.89787 14.7812 9.05899C14.72 9.2201 14.6228 9.36732 14.4895 9.50065ZM4.55615 5.33398C4.83393 5.33398 5.07004 5.23676 5.26449 5.04232C5.45893 4.84787 5.55615 4.61176 5.55615 4.33398C5.55615 4.05621 5.45893 3.8201 5.26449 3.62565C5.07004 3.43121 4.83393 3.33398 4.55615 3.33398C4.27837 3.33398 4.04226 3.43121 3.84782 3.62565C3.65337 3.8201 3.55615 4.05621 3.55615 4.33398C3.55615 4.61176 3.65337 4.84787 3.84782 5.04232C4.04226 5.23676 4.27837 5.33398 4.55615 5.33398Z",
    fill: "#009980"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/sell.ee808fe60e7f0b618fe8771ce5592444.svg";
export { ForwardRef as ReactComponent };